<template>
  <div>
    <b-row>
      <b-col>
        <div class="page-header">
          <h1>Integration Management</h1>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <AccountLinkCard v-if="links.fitbit" :name="links.fitbit.display" :linkMethod="signIn" :unlinkMethod="signOut" :relinkMethod="signIn" :linked="links.fitbit.linked" />
      </b-col>
      <b-col>
        <b-card title="Operations"
                style="max-width: 20rem; text-align: center;">
          <div>
            <b-button v-on:click="requeueDead" variant="danger">Requeue dead messages</b-button>
            <b-button v-on:click="getFitbitSubscriptions" variant="primary">List fitbit subscriptions</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// import Vue from 'vue'
import AccountLinkCard from '@/components/AccountLinkCard'
import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  components: {
    AccountLinkCard
  },
  computed: {
    ...mapGetters({ currentUser: 'currentUser' })
  },
  data: function (router) {
    return {
      section: 'Home',
      loading: '',
      response: '',
      links: {}
    }
  },
  created () {
    this.loadLinks()
  },
  methods: {
    loadLinks () {
      this.$http.get(this.$apiEndpoint + '/links', {
        headers: {
          Authorization: 'Bearer ' + this.currentUser.token
        }
      }).then(function (request) {
        this.links = request.data
      }, reason => {
        console.log('Error while requesting links: ' + reason)
      })
    },
    testSignIn: function () {
      console.log('https://' + this.$apiHost + '/fitness/fitbit/token')
    },
    signIn: function () {
      this.$http.get(this.$apiEndpoint + '/fitness/fitbit/token', {
        headers: {
          Authorization: 'Bearer ' + this.currentUser.token
        }
      }).then(function (request) {
        var token = request.data.token
        var config = {
          state: token,
          scope: 'profile weight',
          response_type: 'code',
          client_id: '22CVTM',
          redirect_uri: 'https://' + this.$apiHost + '/fitness/fitbit'
        }
        var params = []
        for (var p in config) {
          params.push(encodeURIComponent(p) + '=' + encodeURIComponent(config[p]))
        }
        var url = 'https://www.fitbit.com/oauth2/authorize?' + params.join('&')
        window.open(url, '', 'height=768,width=600')
      })
    },
    signOut: function () {
      this.$http.post(this.$apiEndpoint + '/fitness/fitbit/destroy', '', {
        headers: {
          Authorization: 'Bearer ' + this.currentUser.token
        }
      }).then(request => {}, error => {
        console.log('Failed to unlink fitbit: ' + error)
      })
    },
    requeueDead: function () {
      this.$http.post(this.$apiEndpoint + '/requeue', null, {
        headers: {
          Authorization: 'Bearer ' + this.currentUser.token
        }
      }).then(function (request) {
        var queued = request.data.queued
        console.log(queued)
      })
    },
    getFitbitSubscriptions: function () {
      this.$http.get(this.$apiEndpoint + '/fitness/fitbit/subscriptions', {
        headers: {
          Authorization: 'Bearer ' + this.currentUser.token
        }
      }).then(function (request) {
        var resp = request.data
        console.log(resp)
      })
    }
  }
}
</script>
